module.exports = __webpack_public_path__ + "img/soldier_fbs_samurai_01.ba2c7e2c.png";